var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5645 16.6308C10.7935 16.6841 10.8145 16.9839 10.5915 17.0583V17.0583L9.2748 17.4916C5.96646 18.5583 4.2248 17.6666 3.1498 14.3583L2.08313 11.0666C1.01646 7.75827 1.8998 6.00827 5.20813 4.9416L5.64479 4.79699C5.98051 4.68581 6.30723 5.02253 6.21191 5.36309C6.16465 5.5319 6.1192 5.70807 6.0748 5.8916L5.25813 9.38327C4.34146 13.3083 5.68313 15.4749 9.60813 16.4083L10.5645 16.6308Z",
    fill: "#00B135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3083 2.67444L12.9167 2.34944C10.1333 1.6911 8.47499 2.23277 7.49999 4.24944C7.24999 4.75777 7.04999 5.37444 6.88332 6.08277L6.06665 9.57444C5.24999 13.0578 6.32499 14.7744 9.79999 15.5994L11.2 15.9328C11.6833 16.0494 12.1333 16.1244 12.55 16.1578C15.15 16.4078 16.5333 15.1911 17.2333 12.1828L18.05 8.69944C18.8667 5.2161 17.8 3.4911 14.3083 2.67444ZM12.7417 11.1078C12.6667 11.3911 12.4167 11.5744 12.1333 11.5744C12.0833 11.5744 12.0333 11.5661 11.975 11.5578L9.54999 10.9411C9.21665 10.8578 9.01665 10.5161 9.09999 10.1828C9.18332 9.84944 9.52499 9.64944 9.85832 9.73277L12.2833 10.3494C12.625 10.4328 12.825 10.7744 12.7417 11.1078ZM15.1833 8.2911C15.1083 8.57444 14.8583 8.75777 14.575 8.75777C14.525 8.75777 14.475 8.74944 14.4167 8.7411L10.375 7.7161C10.0417 7.63277 9.84165 7.2911 9.92499 6.95777C10.0083 6.62444 10.35 6.42444 10.6833 6.50777L14.725 7.53277C15.0667 7.60777 15.2667 7.94944 15.1833 8.2911Z",
    fill: "#00B135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.c82cf483b3da76a5ca182d927a3a721f.svg";
export { ForwardRef as ReactComponent };